import { Injectable } from '@angular/core';
import { ApiClientService } from './util/api.client.service';

@Injectable({
  providedIn: 'root'
})
export class RecordService {

  constructor(public http: ApiClientService) { }

  getCertificatesByFilter(officeId: any, model: any) {
    return this.http.get(`/secure/certificate/office/${officeId}/filter?docNumber=${model.docNumber}&sex=${model.sex}&sectionalItemId=${model.sectionalItemId}&dateFrom=${model.dateFrom}&dateTo=${model.dateTo}&size=10&assigned=${model.assigned}`);
  }


  getCertificateById(recordId: any) {
    return this.http.post(`/secure/certificate/`, recordId);
  }

  getRecordType(){
    return this.http.get('/sectional/sectionalItem/certificates');
  }

  getNumberOfPersonbyDay(officeId: any, date:any){
    return this.http.get(`/secure/certificate/office/${officeId}/checkDay?date=${date}`);
  }

  confirmCertificateAppointment(certificateId: any, appointment:any){
    return this.http.put(`/secure/certificate/${certificateId}/confirm`,appointment)
  }

  cancelCertificateAppointment(certificateId: any, appointment:any,reassign:any ){
    return this.http.put(`/secure/certificate/${certificateId}/cancel?reassign=${reassign}`,appointment)
  }
}
